import { Application } from "@hotwired/stimulus"
import InlineEditController from "./inline_edit_controller"
import NotificationsController from "./notifications_controller"
import ChatbotController from "./chatbot_controller"
import GlobalSearchController from "./global_search_controller"
import AjaxAutocompleteController from "./ajax_autocomplete_controller"
import ComplaintMultiselectController from "./complaint_multiselect_controller"

const application = Application.start()
application.register("inline-edit", InlineEditController)
application.register("notifications", NotificationsController)
application.register("chatbot", ChatbotController)
application.register("global-search", GlobalSearchController)
application.register("ajax-autocomplete", AjaxAutocompleteController)
application.register("complaint-multiselect", ComplaintMultiselectController)
